import getCurrencies from './currencies';

const currencies = getCurrencies();

export default function getDefaultChannelDealInfo(currency) {
  return [
    {
      type: 'subscription',
      price: currencies[currency].subscription.default,
      enabled: false,
    },
  ];
}
